// import "./UploadNewsForm.css";
import {
  Card,
  CardContent,
  TextField,
  Stack,
  Box,
  Button,
  Typography,
  Breadcrumbs,
  Link,
} from "@mui/material";
import React, { useState } from "react";

function UploadNewsForm({
  customsubmit,
  breadCrumbLink,
  breadCrumbText,
  goBackLink,
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState(null);

  const handleFile = (e) => {
    const selectedFile = e.target.files[0];
    setImage(selectedFile);

    // Create a preview of the selected image
    const reader = new FileReader();
    reader.onload = () => {
      setImagePreview(reader.result);
    };
    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async () => {
    try {
      await customsubmit(title, description, image);
    } catch (error) {
      throw error;
    }
  };
  return (
    <Stack
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "100%", sm: "100%" },
      }}
    >
      <Card>
        <CardContent>
          <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: 20 }}>
            <Link
              underline="hover"
              color="inherit"
              href={goBackLink}
              variant="h5"
            >
              {breadCrumbLink}
            </Link>
            <Link underline="hover" color="inherit" variant="h5">
              {breadCrumbText}
            </Link>
          </Breadcrumbs>
          <Box
            display="grid"
            rowGap={3}
            columnGap={2}
            gridTemplateColumns={{
              xs: "repeat(1,1fr)",
              sm: "repeat(1,1fr)",
              md: "repeat(2,1fr)",
            }}
          >
            <Stack
              style={{ display: "flex", flexDirection: "column", gap: 15 }}
            >
              <TextField
                variant={"outlined"}
                label="title"
                onChange={(e) => setTitle(e.target.value)}
              />
              <Stack
                className="container"
                style={{ border: "1px solid lightgrey", borderRadius: 5 }}
              >
                <input type="file" onChange={handleFile} />
                {imagePreview ? (
                  <Stack
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={imagePreview}
                      alt="Selected"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        marginTop: 10,
                      }}
                    />
                  </Stack>
                ) : (
                  <Stack
                    style={{
                      height: "20vh",
                      alignContent: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <Typography>Allowed *.jpeg, *.jpg, *.png </Typography>
                  </Stack>
                )}
              </Stack>
            </Stack>
            <TextField
              variant={"outlined"}
              label="description"
              multiline
              onChange={(e) => setDescription(e.target.value)}
            />
          </Box>
          <Stack
            alignItems={{ xs: "initial", sm: "initial", md: "flex-end" }}
            style={{
              display: "flex",
              marginTop: 20,
            }}
          >
            <Button
              type="submit"
              color="primary"
              variant="contained"
              sx={{ borderRadius: "8px" }}
              disabled={!title && !description}
              onClick={handleSubmit}
            >
              Upload
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}

export default UploadNewsForm;
